import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { DomainData } from "../model/domain-data";

export function vatNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const error: ValidationErrors = {pattern: true};

        if(!control.value) {
            return null;
        }

        if(! /^[0-9]{11}$/.test(control.value)) {
            return error;
        }
        
        var s = 0;
        for (let i=0; i<=9; i+=2) {
            s += control.value.charCodeAt(i) - '0'.charCodeAt(0);
        }
        
        for (let i=1; i<=9; i+=2 ) {
            let c = 2*(control.value.charCodeAt(i) - '0'.charCodeAt(0));
            if (c > 9) {
                c = c - 9;
            }

            s += c;
        }
        
        const controllo = (10 - s % 10) % 10;
            
        return controllo == control.value.charCodeAt(10) - '0'.charCodeAt(0) ? null : error;
    }
}

export function fiscalCodeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const error: ValidationErrors = {pattern: true};

        if(!control.value) {
            return null;
        }

        var cf = control.value.toUpperCase();
        
        if(! /^[0-9A-Z]{16}$/.test(cf)) {
            return error;
        }
        
        var s = 0;
        var even_map = "BAFHJNPRTVCESULDGIMOQKWZYX";
        for(var i = 0; i < 15; i++) {
            var c = cf[i];
            var n = 0;
            
            if("0" <= c && c <= "9") {
                n = c.charCodeAt(0) - "0".charCodeAt(0);
            } else {
                n = c.charCodeAt(0) - "A".charCodeAt(0);
            }
            
            if((i & 1) === 0) {
                n = even_map.charCodeAt(n) - "A".charCodeAt(0);
            }
            
            s += n;
        }
        
        if(s%26 + "A".charCodeAt(0) !== cf.charCodeAt(15)) {
            return error;
        }
        
        return null;
    }
}

export function cityRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        return control.value && control.value.id ? null : {required: true};
    }
}

export function dropdownValidator(domain: DomainData[]): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    return c.value && domain.find(d => d.key === c.value) === undefined ? {invalid: true} : null;
  }
}

export function autocompleteValidator(domain: DomainData[]): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    return c.value && domain.find(d => d.key === c.value.key) === undefined ? {invalid: true} : null;
  }
}

export function notEmptyValidator(): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    const value = c.value;
    return value && value.length > 0 ? null : {required: true};
  }
}
